<!-- //
侧边分组管理
@author xuyd
@date 2024-08-07
//-->
<template>
  <SideTree ref="refSideTree"
            :width="width"
            :load="getGroupList"
            :pageableLoad="getFileLogList"
            :default-props="defaultProps"
            default-current-node="first"
            @download="handleGroupDownload"
            @delete="handleGroupDelete"
            @change="handleGroupChange"
  >
  </SideTree>
</template>
<script>

import FileLogApi from '@/api/sys/sysFileLog.api.js';
import SideTree from './sidetree/index.vue';

export default {
  name: 'CompFileLogGroup',
  components: {
    SideTree
  },
  data() {
    return {
      defaultProps: {children: 'children', label: 'text', isLeaf: 'leaf', tipKey:'tip'},
    }
  },
  props: {
    width: {
      type: Number,
      default: 350,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    queryParams: {
      type: Object,
      default: () => {
        return {
          pageNum: 1,
          pageSize: 4,
        }
      }
    },
  },
  methods: {
    getGroupList(params) {
      let p = {...this.queryParams, ...params};
      return new Promise(resolve => {
        // 分层单独lazy加载查询，每次都是list返回，不用处理成tree结果
        FileLogApi.selectGroupList(p).then(resp => {
          // 统计且标记head和tail
          // let treeList = this.$util.listToTree(resp.data,{idField: "code", pidField: "pcode", virtualRoot: false});
          resolve(resp.data);
        })
      })
    },
    getFileLogList(nodeData) {// 父级IP节点
      let p = {...this.queryParams, ...nodeData};
      return new Promise(resolve => {
        FileLogApi.searchFileLogList(p).then(resp => {
          resolve(resp.data);
        }).catch(err => {
          console.error("加载文件列表err", err)
        })
      })
    },
    handleGroupDownload(id, resolve) {
      FileLogApi.downloadFileLog({ids: [id]}).then(resp => {
        resolve(resp.data);
      })
    },
    handleGroupDelete(data, resolve) {
      FileLogApi.deleteFileLog(data).then(resp => {
        resolve(resp.data);
      })
    },
    handleGroupChange(data) {
      this.$emit('change', data);
    },
  }

}
</script>

<style lang="less" scoped>
</style>
